const { filterSections } =
  await import(`./filter-sections.js?v=${Date.now()}`);
const { bodyLock } = await import(`./body-lock.js?v=${Date.now()}`);
class FilterInteraction extends HTMLElement {
  constructor() {
    super();
    const fieldset = this.querySelector("fieldset");
    const drawer = document.querySelector(".filter-drawer");
    const section_id = drawer.dataset.sectionId ? drawer.dataset.sectionId : null;
    const activeFilters = this.querySelectorAll(".js-active-button");
    const resultsButton = this.querySelector(".js-results");
    const removeAllFilters = this.querySelector(".delete-holder__button");
    const collapsable = this.querySelectorAll(".js-collapsable");
    URLSearchParams.prototype.remove = (key, value, url) => {
      const entries = url.searchParams.getAll(key);
      const newEntries = entries.filter((entry) => entry !== value);
      url.searchParams.delete(key);
      newEntries.forEach((newEntry) => url.searchParams.append(key, newEntry));
    };
    const changeAndRenderUrl = (e, url) => {
      const currentFilter = url.searchParams.get(`${e.target.dataset.url}`);
      if (currentFilter && url.href.includes(e.target.dataset.filter) === false) {
        url.searchParams.append(`${e.target.dataset.url}`, e.target.dataset.filter);
        filterSections(url.toString() + `&section=${section_id}`);
      } else {
        url.searchParams.set(`${e.target.dataset.url}`, e.target.dataset.filter);
        filterSections(url.toString() + `&section=${section_id}`);
      }
    };
    const handleUrlChange = (e) => {
      const url = new URL(window.location);
      if (e.target.checked) {
        changeAndRenderUrl(e, url);
      } else {
        url.searchParams.remove(`${e.target.dataset.url}`, e.target.dataset.filter, url);
        document.querySelectorAll("input[data-filter]").forEach((input) => {
          if (input.dataset.filter === e.target.dataset.filter) input.checked = false;
        });
        url.toString().includes("?") ? filterSections(url.toString() + `&section=${section_id}`) : filterSections(url.toString() + `?section=${section_id}`);
      }
      history.pushState("filter", "", url);
    };
    const removeFilters = () => {
      const url = new URL(window.location);
      url.searchParams.forEach((filter, key) => {
        url.searchParams.remove(key, filter, url);
      });
      history.pushState("remove filters", "", url);
      filterSections(url.toString() + `?section=${section_id}`);
      drawer.classList.add("filter-drawer--hidden");
      document.querySelectorAll(".quick-filter .filter-checkboxes .checkbox-list .boxes input").forEach((inp) => {
        inp.checked = false;
      });
    };
    if (fieldset) {
      fieldset.addEventListener("change", (e) => {
        handleUrlChange(e);
      });
    }
    if (activeFilters && resultsButton && removeAllFilters) {
      activeFilters.forEach((filter) => {
        filter.addEventListener("click", (e) => {
          handleUrlChange(e);
        });
      });
      resultsButton.addEventListener("click", () => {
        bodyLock.unlock();
        drawer.classList.add("filter-drawer--hidden");
      });
      removeAllFilters.addEventListener("click", (e) => {
        removeFilters();
      });
    }
    if (collapsable) {
      collapsable.forEach((item) => {
        item.addEventListener("click", (e) => {
          item.nextElementSibling.classList.toggle("checkbox-list--open");
          item.closest(".js-collapsable").classList.toggle("text-holder--active");
        });
      });
    }
  }
}
if (customElements.get("filter-interaction") === void 0) {
  customElements.define("filter-interaction", FilterInteraction);
}
